export default "/images/not-linked.svg";